import React from 'react';
import PropTypes from 'prop-types';

import './LocationOneFooter.css';
import strataLogoHoriz from '../../shared/assets/strata-logo-white-horiz.png';

export default function LocationOneFooter({ copyrightYear }) {
  return (
    <footer>
      <div className="footer-strata-section">
        <a href="http://www.strataplatforms.com" target="_blank" rel="noopener noreferrer">
          <img src={strataLogoHoriz} alt="Strata Platforms logo" className="footer-logo" />
        </a>
      </div>
      <div className="footer-stacked-section">
        <div className="footer-info-section">
          <ul>
            <li>Help: support@strataplatforms.com</li>
            <li>|</li>
            <li><a href="http://www.locationone.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            <li>|</li>
            <li><a href="http://www.locationone.com/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a></li>
            <li>|</li>
            <li><a href="http://www.linkedin.com/company/strataplatforms" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          </ul>
        </div>
        <div className="footer-copyright-section">
          <p>Operating globally from Greenville, SC, USA</p>
          <p>&copy;{copyrightYear} Strata Platforms. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

LocationOneFooter.propTypes = {
  copyrightYear: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

LocationOneFooter.defaultProps = {
  copyrightYear: new Date().getFullYear(),
};



// WEBPACK FOOTER //
// ./src/components/LocationOneFooter/LocationOneFooter.js